import * as React from 'react'
import { OrganizationsListItemFragment } from '~api/fragments/OrganizationsListItem.generated'
import { StyledListing, StyledTilesView } from '~components/Listing'
import OrganizationsListItem from './OrganizationsListItem'

interface ComponentProps {
  items: Array<OrganizationsListItemFragment>
  placeholder: string
}

const OrganizationsList: React.FC<ComponentProps> = ({ placeholder, items }) => {
  if (items.length) {
    return (
      <StyledTilesView.Grid>
        {items.map(organization => (
          <OrganizationsListItem key={organization.id} organization={organization} />
        ))}
      </StyledTilesView.Grid>
    )
  }
  return <StyledListing.ListingListPlaceholder>{placeholder}</StyledListing.ListingListPlaceholder>
}

export default OrganizationsList
